import './page-basket';
import './page-catalog';
import './page-catalog-detail';
import './page-order';
import './page-personal';
import './page-personal-orders';
import './page-personal-delivery';
